import { Card} from "react-bootstrap";
import { ContainerHeader } from "./style";

interface PropsIbox {
    title?: string;
    tools?: any
    children: any;
    className?: string
}

export function Ibox({ children, title, tools, className = "mt-5" }: PropsIbox) {
    return (
        <Card className={className}>
            {title || tools ? (
                <Card.Header>
                    <ContainerHeader>
                        <div>{title}</div>
                        <div>{tools}</div>
                    </ContainerHeader>
                </Card.Header>
                ) : ''
            }
            <Card.Body>
                {children}
            </Card.Body>
        </Card>
    );
}